var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',[(_vm.$route.hash=='')?_c('landing-header'):_vm._e(),_c('main',[_c('router-view')],1),(_vm.$route.hash=='')?_c('landing-footer'):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }